"use server";

import { getServerSession } from "next-auth";
import { authOptions } from "@/lib/auth";
import { prisma } from "@/lib/prisma";
import { revalidatePath } from "next/cache";

export async function createSavingGoal(formData: FormData) {
    const session = await getServerSession(authOptions);
    if (!session?.user?.email) return { error: "Not authenticated" };

    const name = formData.get("name") as string;
    const targetAmount = parseFloat(formData.get("amount") as string);

    if (!name || isNaN(targetAmount)) return { error: "Invalid data" };

    const user = await prisma.user.findUnique({
        where: { email: session.user.email },
    });

    if (!user) return { error: "User not found" };

    await prisma.savingGoal.create({
        data: {
            userId: user.id,
            name,
            targetAmount,
        },
    });

    revalidatePath("/");
    return { success: true };
}
